import { withStyles, Card, Button } from '@material-ui/core';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import RefreshIcon from '@material-ui/icons/Refresh';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { LUCKEY_SERVICE_STATUS_LINK } from '../_config/consts.js';
import { isMobileBrowser } from '../_config/utils';

const styles = theme => ({
  '@keyframes scaleIn': {
    '0%': {
      transform: 'scale(0)',
      opacity: 0,
    },
    '50%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
    }
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0.7)',
    },
    '70%': {
      boxShadow: '0 0 0 20px rgba(255, 152, 0, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0)',
    }
  },
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#157495',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    padding: '40px 20px',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
      zIndex: 0,
    },
  },
  contentCard: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '60%',
    width: '100%',
    padding: '38px',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    textAlign: 'center',
  },
  logo: {
    height: '60px',
    marginBottom: '32px',
    display: 'block',
    margin: '0 auto 32px',
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
    margin: '0 auto 24px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 152, 0, 0.1)',
    animation: '$pulse 2s infinite',
  },
  icon: {
    color: '#FF9800',
    fontSize: '48px',
    animation: '$scaleIn 0.5s ease-out',
  },
  title: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '16px',
    marginTop: 0,
  },
  description: {
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '24px',
  },
  link: {
    color: '#157495',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    textDecoration: 'underline',
    marginBottom: '32px',
    display: 'inline-block',
    '&:hover': {
      color: '#0d5570',
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '24px',
  },
  primaryButton: {
    backgroundColor: '#157495',
    color: 'white',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#0d5570',
    },
  },
  secondaryButton: {
    backgroundColor: '#FF9800',
    color: 'white',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#e68900',
    },
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '32px',
    paddingTop: '24px',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  },
  footerText: {
    fontSize: '12px',
    color: '#999',
    margin: 0,
  },
});

@connect(state => ({}))
class ServiceUnavailableView extends React.Component {

  onReload() {
    const { dispatch } = this.props;
    dispatch(push('/'));
  }

  onGoToLogin() {
    const { dispatch } = this.props;
    dispatch(push('/login'));
  }

  render() {
    const { classes } = this.props;
    const isMobile = isMobileBrowser();
    const year = new Date().getFullYear();

    // Mobile version
    if (isMobile) {
      return (
        <div style={{
          minHeight: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          backgroundColor: '#157495',
        }}>
          <div style={{
            minHeight: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            padding: '40px 20px',
            position: 'relative',
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              minHeight: '100%',
              background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
              zIndex: 0,
              pointerEvents: 'none',
            }} />
            <div style={{
              position: 'relative',
              zIndex: 2,
              width: '100%',
              maxWidth: '400px',
              textAlign: 'center',
            }}>
              <img 
                src="/imgs/common/logoJagoWhite.png" 
                alt="Luckey" 
                style={{
                  height: '50px',
                  marginBottom: '40px',
                  display: 'block',
                  margin: '0 auto 40px',
                }}
              />
              <Card style={{
                padding: '32px 24px',
                borderRadius: '16px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '64px',
                  height: '64px',
                  margin: '0 auto 20px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 152, 0, 0.1)',
                }}>
                  <CloudOffIcon style={{ 
                    color: '#FF9800', 
                    fontSize: '40px',
                  }} />
                </div>
                <h1 style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#333',
                  marginBottom: '12px',
                  marginTop: 0,
                }}>
                  <Entity entity="serviceUnavailableTitle" />
                </h1>
                <p style={{
                  fontSize: '14px',
                  color: '#666',
                  lineHeight: '1.6',
                  marginBottom: '16px',
                }}>
                  <Entity entity="serviceUnavailableDescription" />
                </p>
                <a 
                  href={LUCKEY_SERVICE_STATUS_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#157495',
                    fontSize: '14px',
                    fontWeight: '600',
                    textDecoration: 'underline',
                    display: 'inline-block',
                    marginBottom: '24px',
                  }}
                >
                  <Entity entity="verifyServiceStatus" />
                </a>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: '#157495',
                      color: 'white',
                      padding: '10px 24px',
                      fontSize: '14px',
                      fontWeight: '600',
                      textTransform: 'none',
                      borderRadius: '8px',
                    }}
                    onClick={() => this.onReload()}
                    startIcon={<RefreshIcon />}
                  >
                    <Entity entity="reload" />
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: '#FF9800',
                      color: 'white',
                      padding: '10px 24px',
                      fontSize: '14px',
                      fontWeight: '600',
                      textTransform: 'none',
                      borderRadius: '8px',
                    }}
                    onClick={() => this.onGoToLogin()}
                    startIcon={<ExitToAppIcon />}
                  >
                    <Entity entity="backToLogin" />
                  </Button>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '24px',
                  paddingTop: '24px',
                  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
                }}>
                  <span style={{ fontSize: '12px', color: '#999', margin: 0 }}>Sofia part of ISEO ©{year}</span>
                </div>
              </Card>
            </div>
          </div>
        </div>
      );
    }

    // Desktop version
    return (
      <div className={classes.root}>
        <Card className={classes.contentCard}>
          <img 
            src="/imgs/common/logoJagoDark.png" 
            alt="Luckey" 
            className={classes.logo}
          />
          <div className={classes.iconWrapper}>
            <CloudOffIcon className={classes.icon} />
          </div>
          <h1 className={classes.title}>
            <Entity entity="serviceUnavailableTitle" />
          </h1>
          <p className={classes.description}>
            <Entity entity="serviceUnavailableDescription" />
          </p>
          <a 
            href={LUCKEY_SERVICE_STATUS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            <Entity entity="verifyServiceStatus" />
          </a>
          <div className={classes.buttonsContainer}>
            <Button
              variant="contained"
              className={classes.primaryButton}
              onClick={() => this.onReload()}
              startIcon={<RefreshIcon />}
            >
              <Entity entity="reload" />
            </Button>
            <Button
              variant="contained"
              className={classes.secondaryButton}
              onClick={() => this.onGoToLogin()}
              startIcon={<ExitToAppIcon />}
            >
              <Entity entity="backToLogin" />
            </Button>
          </div>
          <div className={classes.footer}>
            <span className={classes.footerText}>Sofia part of ISEO ©{year}</span>
          </div>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(ServiceUnavailableView);
